import React from 'react';
import classNames from 'classnames';
import { Section } from '../../enums/container';
import { VideoSection } from '../../templates/VideoSection';
import { OpportunitySection } from '../../templates/OpportunitySection';
import { Wrapper } from '../../atoms/wrapper';
import * as styles from './big_section.module.sass';

export const BigSection = (props: any) => {
  return (
    <div className={classNames(styles.sections, styles._default)}>
      <Wrapper section={Section.GRAY} className={styles._default}>
        <OpportunitySection
          title={props.opportunityTitle}
          src={props.src}
          iconWithText={props.iconWithText}
          containerClassName={props.containerClassName}
          imgAbilityClass={props.imgAbilityClass}
          className={props.className}
        />
        <VideoSection title={props.videoTitle} src={props.videoSrc} videoInfo={props.videoInfo} />
      </Wrapper>
    </div>
  );
};
